/**
 * Shared MF auth (Zustand persist `authStore`) vs host legacy `localStorage.token`.
 *
 * Payments: `window.dispatchEvent(new CustomEvent(BSFOOD_AUTH_LOGOUT_EVENT))` after 401.
 * Host UI: `HostSessionExpiredDialog` listens, shows ErrorDialog, clears storage, redirects.
 * This module also wires Zustand subscribe + optional persist mismatch dispatch.
 */

export const BSFOOD_AUTH_LOGOUT_EVENT = 'bsfood:auth-logout';

const PERSIST_KEY = 'authStore';

function persistHasNoToken(rawJson) {
  try {
    const t = JSON.parse(rawJson)?.state?.token;
    return t == null || t === '';
  } catch {
    return false;
  }
}

/**
 * After React mounts, if persist says logged out but legacy `token` exists, fire the same
 * event as payments (so one UI handler covers reload desync).
 */
export function dispatchPersistLegacyMismatchIfNeeded() {
  if (typeof window === 'undefined') return;

  try {
    const raw = window.localStorage.getItem(PERSIST_KEY);
    if (!raw || !persistHasNoToken(raw)) return;
    if (window.localStorage.getItem('token')) {
      window.dispatchEvent(new CustomEvent(BSFOOD_AUTH_LOGOUT_EVENT));
    }
  } catch (e) {
    console.warn('[syncSharedStoreToken] persist dispatch:', e);
  }
}

function dispatchHostSessionExpired() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(BSFOOD_AUTH_LOGOUT_EVENT));
}

export async function initSharedStoreTokenSync() {
  try {
    const mod = await import('store/Store');
    const store = mod.default;
    let prevToken = store.getState()?.token;

    store.subscribe((state) => {
      const next = state?.token;
      if (prevToken && !next && window.localStorage.getItem('token')) {
        dispatchHostSessionExpired();
      }
      prevToken = next;
    });
  } catch (e) {
    console.warn('[syncSharedStoreToken] store remote non disponibile:', e);
  }
}
